import React from 'react';

import { DescriptionList, DescriptionItem } from '@gogame/components';

import { Status } from '../components/Status';

const Metadata = ({ data = {} }) => {
  return (
    <DescriptionList
      variant={'column'}
      data={{ ...data, status: { id: data?.status } }}
      stripEmpty={true}
      disableGutters={true}
    >
      <DescriptionItem
        label={'Status'}
        field={'status'}
        type={'status'}
        statusFactory={Status}
      />
      <DescriptionItem
        label={'Run date'}
        type={'date'}
        value={data.lastRun || data.dateStartApprovalSent}
      />
    </DescriptionList>
  );
};

export default Metadata;
